import { Flex, Tag } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CreditCardOutlined,
  DollarCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { BillingMode } from '../../services/exports/Constants';

function SubscriptionTags({ subscription }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Billing:SubscriptionTags' });

  const { company } = useSelector((store) => store.currentCompany);

  const isLive = company.live_from !== null;

  return (
    <Flex gap="small" className="h-fit">
      <Tag
        icon={subscription.billing_mode === BillingMode.Stripe ? <CreditCardOutlined /> : <DollarCircleOutlined />}
        color="black"
      >
        {t(`tags.${subscription.billing_mode}`)}
      </Tag>
      {subscription.is_active && isLive && subscription.collects_payments && (
        <Tag icon={<CheckCircleOutlined />} color="success">
          {t('tags.active')}
        </Tag>
      )}
      {subscription.is_on_trial && isLive && subscription.collects_payments && (
        <Tag icon={<SyncOutlined spin />} color="processing">
          {t('tags.on_trial')}
        </Tag>
      )}
      {!isLive && !subscription.collects_payments && (
        <Tag icon={<ClockCircleOutlined />} color="default">
          {t('tags.launch_pending')}
        </Tag>
      )}
      {isLive && !subscription.collects_payments && (
        <Tag icon={<WarningOutlined />} color="error">
          {t('tags.billing_disabled')}
        </Tag>
      )}
      {subscription.is_resumable && (
        <Tag icon={<ClockCircleOutlined />} color="warning">
          {t('tags.on_grace_period')}
        </Tag>
      )}
      {subscription.is_past_due && (
        <Tag icon={<ClockCircleOutlined />} color="warning">
          {t('tags.past_due')}
        </Tag>
      )}
      {!subscription.is_active && (
        <Tag icon={<MinusCircleOutlined />} color="error">
          {t('tags.cancelled')}
        </Tag>
      )}
    </Flex>
  );
}

export default SubscriptionTags;
